import { ITaskExportRequestSettings } from '../interfaces/taskExportRequestSettings';
import { EnergyOrGasContract } from '../enums/energyOrGasContract.enum';
import { TypeExportContract } from '../enums/typeExportContract';

export class TaskExportRequestSettings implements ITaskExportRequestSettings {
    public energyOrGas: EnergyOrGasContract;
    public fromDate: Date;
    public toDate: Date;
    typeExport: TypeExportContract;
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/taskExportRequestSettings.ts